module.exports = __webpack_public_path__ + "static/media/mobile_nav.85d8616d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_nav.svg
// module id = 849
// module chunks = 3